import {RegisterClazz} from "../RegisterType";

@RegisterClazz(Avatar)
export class Avatar {
	public bgColor:string = "#c3743a";
	public version:number = 1;
	public exists:boolean = false;
}
